import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Moment } from "moment";
import { LogService } from "app/services/log.service";
import { DataService } from 'app/services/data.service';

declare let Strophe: any;
declare let $pres: any;
declare let $iq: any;
declare let $msg: any;

@Injectable()

export class XmppService {
    host = window.location.host.split(':')[0];
    chatUrl = this.host;

    one2oneDomain = "";

    wsUrl: any;

    chatConnection: any;
    username = "";
    password = "";
    client: any;
    groupMessages = {};
    one2OneRooms = [];
    joinedOne2OneRooms = [];
    unread_count = [];
    user_status = {};
    message_received_notifier: any;

    constructor(
        private data_service: DataService,
        private logService: LogService

    ) {
        this.wsUrl = "ws://" + this.chatUrl + ":7070/ws/";

        this.one2oneDomain = "@projectone2one." + this.chatUrl;

        this.chatConnection = new Strophe.Connection(this.wsUrl, {protocol: 'ws'});
    }

    /**
     * Connect to xmpp server
     */
    connectToXmpp(successfulCallback) {
        const callback = (status) => {
            if (status === Strophe.Status.ERROR) {
                this.logService.printError('Strophe error while connecting.');
                successfulCallback(false);
            } else if (status === Strophe.Status.AUTHFAIL) {
                this.logService.printError('Strophe auth failed.');
                successfulCallback(false);
            } else if (status === Strophe.Status.ATTACHED) {
                this.logService.printLog('Strophe is attached.');
            } else if (status === Strophe.Status.CONNECTING) {
                this.logService.printLog('Strophe is connecting.');
            } else if (status === Strophe.Status.CONNFAIL) {
                this.logService.printLog('Strophe failed to connect.');
                successfulCallback(false);
            } else if (status === Strophe.Status.DISCONNECTING) {
                this.logService.printLog('Strophe is disconnecting.');
                successfulCallback(false);
            } else if (status === Strophe.Status.DISCONNECTED) {
                this.logService.printLog('Strophe is disconnected.');
                successfulCallback(false);
            } else if (status === Strophe.Status.CONNECTED) {
                this.logService.printLog('Strophe is connected.');
                successfulCallback(true);
            }
        };

        this.chatConnection.connect(this.username + "@" + this.chatUrl + "/web-app", this.password, callback);
    }

    disconnectFromXMPP() {
        this.groupMessages = {};
        this.one2OneRooms = [];
        this.joinedOne2OneRooms = [];
        this.user_status = {};
        this.chatConnection.disconnect();
        this.chatConnection = new Strophe.Connection(this.wsUrl, {protocol: 'ws'});
    }

    /**
     * Create a random string by providing a length
     * @param len - length for string
     * @returns {string} - Random string
     */
    createRandomString(len) {
        let text = "";
        const charSet = "abcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < len; i++) {
            text += charSet.charAt(Math.floor(Math.random() * charSet.length));
        }
        return text;
    }


    /**
     * Message handler for xmpp
     */
    messageReceived(stanza) {
        this.logService.printLog("Received Message: **** \n");
        this.logService.printLog(stanza);

        let messageId = jQuery(stanza).attr("id");

        if (messageId === undefined) {

            this.logService.printLog("Creating random msg ID");

            messageId = this.createRandomString(10);
        }

        const from = jQuery(stanza).attr("from").split('/')[1];
        const to = jQuery(stanza).attr("to").split('@')[0];
        const type = jQuery(stanza).attr("type");

        let msgAttachment = "";
        let msgBody = "";

        if(type === 'groupchat' || type === 'normal' || type === 'chat') {
            try {
                msgBody = stanza.getElementsByTagName('body')[0]['textContent'];
            } catch (err) {
                this.logService.printLog("no body in this message.");
            }
            try {
                msgAttachment = stanza.getElementsByTagName('attachment')[0].innerHTML;
            } catch (err) {
                this.logService.printLog("no attachment in this message.");
            }

            let delay = stanza.querySelector('delay');
            let messageDate: Moment;

            if (delay == null) {
                messageDate = moment();
            } else {
                delay = delay.getAttribute('stamp');
                messageDate = moment(delay);
            }

            const groupName = jQuery(stanza).attr("from").split('@')[0];
            this.addToGroupMessages(from, msgBody, msgAttachment, groupName, messageId, messageDate);
        }

        return true;
    }

    /**
     * Add message to group messages object
     * @param from
     * @param bodyText
     * @param attachment
     * @param groupNameFull
     * @param messageId
     * @param messageDate
     */
    addToGroupMessages(from, bodyText, attachment, groupNameFull, messageId, messageDate) {

        if (!this.groupMessages[groupNameFull]) {
            this.groupMessages[groupNameFull] = [];
        }

        this.logService.printLog("Message ID " + messageId);

        if (!this.data_service.get_array_details(this.groupMessages[groupNameFull], "messageId", messageId)) {

            this.logService.printLog("Message ID unique");

            this.groupMessages[groupNameFull].push({
                    "messageId": messageId,
                    "msgStatus": 0, // 0: Unread, 1: Read
                    "msgType": (from === this.username) ? 1 : 0, // 0: from self, 1: from someone else
                    "from": from,
                    "messageDate": messageDate,
                    "attachment": attachment,
                    "body": bodyText,
                });

        } else {
            this.logService.printLog("Message ID already exists");
            const obj = this.data_service.get_array_details(this.groupMessages[groupNameFull], "messageId", messageId);
            obj["msgStatus"] = 1;
            obj["messageDate"] = messageDate;
        }

        this.message_received_notifier({
            "group_jid": groupNameFull,
            "read_count": this.groupMessages[groupNameFull].length
        });

        return true;
    }

    /**
     * Handle presence from group users
     * @param presence
     * @returns {boolean}
     */
    groupPresenceHandler (presence) {
        this.logService.printLog("PRESENCE HANDLE");
        this.logService.printLog(presence);

        const from = jQuery(presence).attr("from").split('/')[1];
        const type = jQuery(presence).attr("type");

        this.logService.printLog("Presence : FROM " +  jQuery(presence).attr("from") + " TO : " + jQuery(presence).attr("to"));
        this.user_status[+from] = (type !== 'unavailable');

        this.logService.printLog("Presence : FROM " + from + " is " + this.user_status[+from]);
        return true;
    }

    /**
     * Join a group
     * @param group_name
     */
    joinGroup(group_name) {
        if (!this.joinedOne2OneRooms.find(x=> x === group_name)) {

            this.logService.printLog("XMPP Room now joining: " + group_name);

            this.joinedOne2OneRooms.push(group_name);

            this.chatConnection.muc.join(
                group_name,
                this.username,
                this.messageReceived.bind(this),
                this.groupPresenceHandler.bind(this),
                null
            );

            this.chatConnection.send($pres().c('status').t('Online'));

            // Setup room configuration
            const iq = $iq({
                to: group_name,
                type: 'set'
            }).c("query", {
                xmlns: Strophe.NS.MUC_OWNER
            });
            iq.c("x", {
                xmlns: "jabber:x:data",
                type: "submit"
            });

            iq.c('field', { 'var': 'FORM_TYPE' }).c('value').t('https://jabber.org/protocol/muc#roomconfig').up().up();
            iq.c('field', { 'var': 'muc#roomconfig_publicroom' }).c('value').t(this.username).up().up();

            this.chatConnection.sendIQ(iq.tree(), () => {
                this.logService.printLog('Join Room Success - ', group_name);
            }, function (err) {
                this.logService.printError('Join Room Error - ', group_name, JSON.stringify(err));
            });
        }
    }

    /**
     * Join all one2One Chat Rooms
     */
    joinAllOne2OneRooms() {
        for(let i = 0; i < this.one2OneRooms.length; i++) {
            const one2OneRoom = this.one2OneRooms[i];
            this.joinGroup(one2OneRoom + this.one2oneDomain);
        }
    }

    /**
     * Send one to one message to another user
     * @param to
     * @param from
     * @param message
     * @returns {boolean}
     */
    sendSingleMessage(to, from, message) {
        this.logService.printLog('##############' + 'ECHOBOT: I got a message from ' + from + ': ' + message);
        const reply = $msg({to: to, from: from, type: 'chat'}).c("body").t(message);
        this.logService.printLog("Tree is " + JSON.stringify(reply.tree()));
        this.chatConnection.send(reply.tree());

        // we must return true to keep the handler alive.
        // returning false would remove it after it finishes.
        return true;
    }

    /**
     * Send message to a group
     * @param to
     * @param from
     * @param message
     * @param file
     */
    sendGroupMessage(to, from, message, file=null) {
        // Send presence to test connection
        // const iq = $iq({type: 'get'}).c('query', {xmlns: 'jabber:iq:roster'});
        from = from + "@" + this.chatUrl;
        to = to + this.one2oneDomain;

        const reply = $msg({to: to, from: from, type: 'groupchat', id: this.createRandomString(10)}).c("body").t(message);
        this.chatConnection.send(reply.tree());
    }
}
